import { createSelector } from 'reselect';

const getShopState = (state) => state.shop;

export const getShopPaperSuites = createSelector(getShopState, (shopState) => shopState.paper);
export const getShopAlbums = createSelector(getShopState, (shopState) => shopState.albums);
export const getBrandDirectory = createSelector(getShopState, (shopState) => shopState.directory);
